module.exports = __webpack_public_path__ + "Badge_ModuleWrapup-92982b223bfdc34d528a325eb32bf72b.svg";